import React from 'react';
import { trustIndicators } from '../data/mock';
import { Award, Zap, Layers, Globe } from 'lucide-react';

const iconMap = {
  'award': Award,
  'zap': Zap,
  'layers': Layers,
  'globe': Globe
};

const TrustSection = () => {
  return (
    <section data-testid="trust-section" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 bg-sun-blue/10 text-sun-blue rounded-full text-sm font-semibold mb-4">
            Erfahrung & Kompetenz
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900">
            Qualität, auf die Sie sich
            <span className="text-sun-orange"> verlassen können</span>
          </h2>
        </div>

        {/* Trust Cards Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {trustIndicators.map((card, index) => {
            const IconComponent = iconMap[card.icon] || Award;
            return (
              <div
                key={index}
                data-testid={`trust-card-${index}`}
                className="group bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border border-slate-100 hover:border-sun-orange/30 hover:shadow-xl hover:shadow-sun-orange/5 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="text-4xl font-bold text-sun-orange mb-4">{card.value}</div>
                <div className="w-14 h-14 bg-sun-orange/10 rounded-2xl flex items-center justify-center mb-5 group-hover:bg-sun-orange group-hover:scale-110 transition-all duration-300">
                  <IconComponent className="w-7 h-7 text-sun-orange group-hover:text-white transition-colors" />
                </div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{card.title}</h3>
                <p className="text-slate-600 text-sm leading-relaxed">{card.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
